import { render, staticRenderFns } from "./sidebar_item.vue?vue&type=template&id=081d02cc&scoped=true&lang=pug"
import script from "./sidebar_item.vue?vue&type=script&lang=js"
export * from "./sidebar_item.vue?vue&type=script&lang=js"
import style0 from "./sidebar_item.vue?vue&type=style&index=0&id=081d02cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d02cc",
  null
  
)

export default component.exports